import React, { useState, useEffect, useRef } from 'react';

const QUICK = [100, 200, 500, 1000, 2000, 5000, 10000, 25000];
const MIN_BET = 100;
const MAX_BET = 5000;
const stop = (e) => e.preventDefault();

/* PLACE BET / bet slip. Driven by the `bet` prop set when an odds cell on the
   match page is clicked: { side:'back'|'lay', team, odds, marketName }. When null,
   the panel shows the empty state. No backend — Place Bet is UI-only. */
export default function BetSlip({ bet, onClose }) {
  const [odds, setOdds] = useState('');
  const [stake, setStake] = useState('');
  const stakeRef = useRef(null);

  useEffect(() => { if (bet) { setOdds(String(bet.odds)); setStake(''); } }, [bet]);

  const stepOdds = (dir) => setOdds((o) => {
    const v = Math.min(999.99, Math.max(1.01, (parseFloat(o || '1') + dir * 0.01)));
    return v.toFixed(2);
  });
  const addStake = (amt) => setStake((s) => String((parseInt(s || '0', 10) || 0) + amt));
  const canPlace = !!stake && parseFloat(stake) > 0;

  return (
    <div className="card mb-1 place-bet">
      <div className="card-header">
        <h6 className="card-header game-heading">Place Bet</h6>
      </div>

      {!bet ? (
        <div className="place-bet-empty" />
      ) : (
        <div className={`place-bet-content black-bg-theme ${bet.side === 'lay' ? 'lay-bg-theme lay' : 'back'}`}>
          <div className="table-responsive palce-tab-content">
            <form noValidate onSubmit={stop}>
              <table className="coupon-table table table-borderedless">
                <tbody>
                  <tr className="middlesex-col">
                    <td className="bet-odds">
                      <div className="form-group">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text" role="button" onClick={() => stepOdds(-1)}><i className="bi bi-dash" /></span>
                          </div>
                          <input placeholder="0" type="text" min="1.01" max="999.99" readOnly value={odds} />
                          <div className="input-group-prepend">
                            <span className="input-group-text" role="button" onClick={() => stepOdds(1)}><i className="bi bi-plus" /></span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="bet-stakes">
                      <div className="form-group">
                        <input ref={stakeRef} placeholder="0" required type="number" min="0" value={stake} onChange={(e) => setStake(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="value-buttons">
                      {QUICK.map((v) => (
                        <button type="button" className="btn btn-secondary m-l-5 m-b-5" key={v} onClick={() => addStake(v)}>
                          <i className="bi bi-plus" /> {v}
                        </button>
                      ))}
                      <button type="button" className="btn btn-secondary m-l-5 m-b-5 btn-min-stake" onClick={() => setStake(String(MIN_BET))}>min stake</button>
                      <button type="button" className="btn btn-secondary m-l-5 m-b-5 btn-max-stake" onClick={() => setStake(String(MAX_BET))}>max stake</button>
                      <button type="button" className="btn btn-secondary m-l-5 m-b-5 all-in-stake" onClick={() => stakeRef.current && stakeRef.current.focus()}>Edit Stake</button>
                      <button type="button" className="btn btn-secondary m-l-5 m-b-5 clear-stake" onClick={() => setStake('')}>clear</button>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5}>
                      <p className="bet-stakes">Min Bet: {MIN_BET.toFixed(2)} Max Bet: {MAX_BET.toFixed(2)}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="col-md-12 px-0 text-center">
                <button type="button" className="btn btn-sm btn-danger" onClick={onClose}> cancel </button>
                <button type="button" className="btn btn-sm btn-success" disabled={!canPlace}> place bet </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
